import { render, staticRenderFns } from "./AuthsuccessDialog.vue?vue&type=template&id=4ce35a06&scoped=true&"
import script from "./AuthsuccessDialog.vue?vue&type=script&lang=js&"
export * from "./AuthsuccessDialog.vue?vue&type=script&lang=js&"
import style0 from "./AuthsuccessDialog.vue?vue&type=style&index=0&id=4ce35a06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce35a06",
  null
  
)

export default component.exports